import script from "./MegaNavColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./MegaNavColumn.vue?vue&type=script&setup=true&lang=ts"

import "./MegaNavColumn.vue?vue&type=style&index=0&id=f5901e54&lang=scss"

const __exports__ = script;

export default __exports__